import { computed, onMounted, ref, watch } from 'vue'

import type { PlaygamaCTRContext } from '@/modules/analytics/types'

declare const guard: unique symbol

type CtrContextInput = Partial<PlaygamaCTRContext>
type CtrListContextInput = Omit<CtrContextInput, 'target' | 'position' | 'total' | 'placement'> & {
    placement: string
}
type CtrListItem = { readonly hru: string } | undefined

export type CtrContext = CtrContextInput & {
    readonly [guard]: 'use CTR context composable'
}

function brandCtrContext(context: CtrContextInput): CtrContext {
    return context as CtrContext
}

export function useCtrListContexts<T extends CtrListItem>(
    getItems: () => readonly T[],
    getContext: () => CtrListContextInput,
) {
    const slateId = ref<string>()
    const refreshSlateId = () => {
        const serverSlateId = getContext().slateId
        if (serverSlateId) {
            slateId.value = serverSlateId
            return
        }
        if (import.meta.env.SSR === false) {
            slateId.value = window.crypto.randomUUID()
        }
    }

    watch([getItems, () => getItems().map((item) => item?.hru), getContext], refreshSlateId)
    onMounted(refreshSlateId)

    return computed(() => {
        const items = getItems()
        const context = getContext()

        return items.map((item, index) =>
            item
                ? brandCtrContext({
                      ...context,
                      slateId: slateId.value,
                      position: index + 1,
                      total: items.length,
                  })
                : undefined,
        )
    })
}
